export default __webpack_public_path__ + "static/media/img-new-home-2.89678ca2.png";